import { MessageBar, MessageBarType, TooltipHost } from "@fluentui/react";
import React, { useContext } from "react";
import styled from "styled-components";
import { ColumnOptionsContext } from "./ColumnOptions";

type Props = {
  className?: string;
};

export const ViewDescription = ({ className }: Props) => {
  const { selectedView } = useContext(ColumnOptionsContext);

  if (!selectedView?.userAppSettingDescription) return null;

  return (
    <TooltipHost content={selectedView.userAppSettingDescription}>
      <StyledMessageBar
        messageBarType={MessageBarType.info}
        isMultiline={false}
        className={className}
      >
        <DescriptionText>
          {selectedView.userAppSettingDescription}
        </DescriptionText>
      </StyledMessageBar>
    </TooltipHost>
  );
};

const StyledMessageBar = styled(MessageBar)`
  flex: 1;
  overflow: hidden;
`;

const DescriptionText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 180px;
`;
